import { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Logo from '../../assets/icons/logo-short.svg?react';
import { ROUTES } from '../../constants/routes';
import { usePermissions } from '../../hooks/usePermissions';
import { DASHBOARD_NAV_ITEMS, navItemOwnsSegment } from './navConfig';

export const DashboardSidebar = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const { has, organization } = usePermissions();

  const navItems = useMemo(
    () => DASHBOARD_NAV_ITEMS.filter((item) => item.when?.({ has, organization }) ?? true),
    [has, organization],
  );

  const segment = location.pathname.split('/')[2] ?? '';
  const navLinkClass = (active: boolean) => `nav-link ${active ? 'nav-link-active' : ''}`;

  return (
    <aside className="dashboard-sidebar">
      <Link to={`/${ROUTES.DASHBOARD}`} className="sidebar-logo" aria-label="Electric group">
        <Logo aria-hidden="true" />
      </Link>

      <nav className="sidebar-nav">
        {navItems.map((item) => (
          <Link
            key={item.route}
            to={`/${ROUTES.DASHBOARD}/${item.route}`}
            className={navLinkClass(navItemOwnsSegment(item, segment))}
            title={t(item.labelKey)}
          >
            <span className="material-symbols-outlined">{item.icon}</span>
          </Link>
        ))}
      </nav>

      <div style={{ marginTop: 'auto' }} />
    </aside>
  );
};

export default DashboardSidebar;
